<template>
  <div class="container box profile">
    <h2 class="title">Your profile</h2>
    <hr/>
    <div class="columns-wrapper">
      <div class="columns">
        <div class="column account-info">
          <h3 class="subtitle">Account information</h3>
          <div class="field">
            <label class="label">
              Email
              <span v-if="isConfirmed" class="green">(confirmed)</span>
              <span v-else class="red">(not confirmed)</span>
            </label>
            <div class="control">
              <input class="input email" type="email" disabled v-model="$store.getters.user.email"/>
            </div>
            <div class="control control-button">
              <button class="button is-info is-outlined" @click="isEmailChangeModalActive = true">
                <i class="fa fa-edit"></i>
                <span>Edit</span>
              </button>
            </div>
          </div>
          <div class="field">
            <label class="label">Password</label>
            <div class="control">
              <button class="button is-info is-outlined" @click="isPasswordChangeModalActive = true">
                <i class="fa fa-edit"></i>
                <span>Change</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal :active.sync="isEmailChangeModalActive" :width="420">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Change email</p>
        </header>
        <section class="modal-card-body">
          <b-field label="New email">
            <b-input type="email" v-model="newEmail" placeholder="New email" required/>
          </b-field>
          <b-field label="Confirm with password">
            <b-input type="password" v-model="password" placeholder="Your password"required />
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="isEmailChangeModalActive = false">Close</button>
          <button
            class="button is-primary"
            :disabled="emailChangeDisabled"
            @click="confirmEmailChange()"
          >
            Confirm
        </button>
        </footer>
      </div>
    </b-modal>
    <b-modal :active.sync="isPasswordChangeModalActive" :width="420">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Change password</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Old password">
            <b-input type="password" v-model="oldPassword" placeholder="Old password" required/>
          </b-field>
          <b-field label="New password">
            <b-input type="password" v-model="newPassword" placeholder="New password"required />
          </b-field>
          <b-field label="New password confirmation">
            <b-input
              type="password"
              v-model="newPasswordConfirmation"
              placeholder="New password"
              required
            />
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <button class="button" @click="isPasswordChangeModalActive = false">Close</button>
          <button
            class="button is-primary"
            :disabled="passwordChangeDisabled"
            @click="confirmPasswordChange()"
          >
            Confirm
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'profile',
  data: () => ({
    isEmailChangeModalActive: false,
    isPasswordChangeModalActive: false,
    newEmail: '',
    password: '',
    oldPassword: '',
    newPassword: '',
    newPasswordConfirmation: '',
    areTransactionsLoaded: false,
    transactions: null,
  }),
  computed: {
    subDue() { return this.$store.getters.user.subscriptionDue; },
    isSubbed() { return this.$store.getters.user.isSubbed; },
    isConfirmed() { return this.$store.getters.user.isConfirmed; },
    subDate() { return dayjs.unix(this.subDue).format('YYYY-MM-DD'); },
    emailChangeDisabled() { return this.newEmail === '' || this.password === ''; },
    passwordChangeDisabled() {
      return this.oldPassword === ''
        || this.newPassword === ''
        || this.newPassword !== this.newPasswordConfirmation;
    },
  },
  methods: {
    goToSubs() {
      this.$router.push('/subscription');
    },
    loadTransactions() {
      this.$store.dispatch('get', {
        url: '/payment/transactions',
        onSuccess: (res) => {
          this.transactions = res.data;
          this.areTransactionsLoaded = true;
        },
        onFailure: () => {
          this.errorSnackbar("Couldn't load transactions due to error");
        },
      });
    },
    successSnackbar(message) {
      this.$snackbar.open({
        message,
        type: 'is-success',
        position: 'is-top',
        actionText: 'Ok',
      });
    },
    errorSnackbar(error) {
      this.$snackbar.open({
        message: `There was an error. ${error}`,
        type: 'is-warning',
        position: 'is-top',
        actionText: 'Ok',
      });
    },
    confirmEmailChange() {
      this.$store.dispatch('post', {
        url: '/auth/change/email',
        body: {
          password: this.password,
          newEmail: this.newEmail,
        },
        onSuccess: () => {
          this.successSnackbar('Navigate to your new email to confirm the change');
          this.isEmailChangeModalActive = false;
        },
        onFailure: (err) => {
          if (err.response.data.error === 'email is invalid') {
            this.errorSnackbar('Email is invalid');
          } else if (err.response.data.error === 'incorrect password') {
            this.errorSnackbar('Password is incorrect');
          } else if (err.response.data.error === 'email is taken') {
            this.errorSnackbar('Email is already taken');
          } else {
            this.errorSnackbar('Unknown. Try again later');
          }
        },
      });
    },
    confirmPasswordChange() {
      this.$store.dispatch('post', {
        url: '/auth/change/password',
        body: {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
          newPasswordConfirmation: this.newPasswordConfirmation,
        },
        onSuccess: () => {
          this.successSnackbar('Password was changed successfully');
          this.isPasswordChangeModalActive = false;
        },
        onFailure: (err) => {
          if (err.response.data.error === 'incorrect password') {
            this.errorSnackbar('Old password was incorrect. Try again');
            this.oldPassword = '';
            this.newPassword = '';
            this.newPasswordConfirmation = '';
          } else if (err.response.data.error === 'passwords don\'t match') {
            this.errorSnackbar('Passwords don\'t match. Try again');
            this.newPassword = '';
            this.newPasswordConfirmation = '';
          } else {
            this.errorSnackbar('Error! Try again a bit later!');
          }
        },
      });
    },
  },
  mounted() {
    // this.loadTransactions();
  },
};
</script>

<style scoped>

.top {
  margin-bottom: 20px;
}

.title {
  text-align: left;
}

.subtitle {
  font-size: 28px;
}

.profile {
  min-height: 350px;
  padding-bottom: 30px;
}

.columns-wrapper {
  min-height: 350px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.email {
  max-width: 300px;
  text-align: center;
}

.column {
  padding-left: 40px;
  padding-right: 40px;
}

.control {
  display: flex;
  justify-content: center;
}

.control-button {
  margin-top: 10px;
}

.fa {
  margin-right: 8px;
}

.green {
  color: darkgreen;
}

.red {
  color: darkred;
}

.no-sub {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sub {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.label-bigger {
  font-size: 20px;
}

</style>
